<template>
  <div>
    <page-content>
      <ntm-block :title="$tc('livestream.logo')" :init-collapse="false">
        <template slot="options">
          <span>{{ $t('ratio') }}: <span class="font-weight-bold">{{$t('any')}}</span>, {{ $t('size') }}: <span class="font-weight-bold">500x500</span></span>
        </template>
        <ntm-crop
          v-if="settings.uuid"
          entity-type="settings"
          :entity-uuid="settings.uuid"
          :max-width="500"
          :max-height="500"
          collection="broadcast"
        />
      </ntm-block>

      <form @submit.prevent="onSubmit()">
        <ntm-block>
          <formly-form :form="form" :model="settings" :fields="livestreamFields"></formly-form>
          <button class="btn btn-success push-15">{{ $t('save') }}</button>
        </ntm-block>
      </form>

      <h4>{{ $t('integrations.name') }}</h4>
      <div class="row mb-5">
        <div class="col-sm-6 col-12">
          <section class="p-4 border border-primary w-auto mb-3">
            <h2>YouTube</h2>

            <div v-if="youtubeError" class="alert alert-danger">
              {{ $t(youtubeError) }}
            </div>

            <div v-if="connectedAccounts.YOUTUBE">
              <div class="d-flex" style="gap: 10px">
                <h3 class="m-0">
                  {{ connectedAccounts.YOUTUBE.userName }}
                </h3>

                <button
                  @click="disconnectAccount(connectedAccounts.YOUTUBE)"
                  class="btn btn-danger"
                >
                  <i class="fa fa-close"></i>
                </button>
              </div>
            </div>

            <div v-else>
              <button @click="connectToYoutube()" class="btn btn-info">
                Connect
              </button>
            </div>
          </section>
          <section class="p-4 bg-white w-auto">
            <h4>{{ $t('table.column.livestreamWidget') }}</h4>
            <div class="table-responsive mt-3">
              <table class="table table-bordered table-striped table-vcenter">
                <thead>
                  <tr>
                    <th>{{ $t('table.column.venue') }}</th>
                    <th class="text-center">{{ $t('table.column.actions') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="venue in venues" :key="venue.uuid">
                    <td class="font-w600">{{ venue.name }}</td>
                    <td class="text-center">
                      <button
                        type="button"
                        class="btn btn-sm btn-circle btn-info"
                        v-tooltip="$t('tooltip.copyLink')"
                        @click="copyLiveStreamWidgetLink(venue)"
                      >
                        <i class="fa fa-copy"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
        </div>
      </div>

    </page-content>
  </div>
</template>

<script>
import SettingsService from '@/services/settings.service'
import VenueService from '@/services/venue.service'
import ConnectedAccountService from '@/services/connectedAccount.service'
import { useRouteQuery } from '@/use/useRouteQuery'
import { useExternalLinks } from '@/use/useExternalLinks'
import formDefinition from './formDefinition'

export default {
  name: 'LivestreamSettings',

  data () {
    return {
      settings: {},
      form: {},
      connectedAccounts: {},
      youtubeError: null,
      venues: []
    }
  },

  computed: {
    livestreamFields () {
      return formDefinition.livestreamFields.filter(field => {
        if (field.key === 'show_league_engine_logo_to_livestream') {
          return this.user?.isSuperAdmin
        }

        return true
      })
    },
    user () {
      return this.$store.state.user
    }
  },

  setup () {
    const error = useRouteQuery('error')
    const { getWebsiteDomain } = useExternalLinks()
    return { error, getWebsiteDomain }
  },

  beforeRouteEnter (to, from, next) {
    Promise.all([
      SettingsService.index(),
      ConnectedAccountService.index()
    ]).then(([settingsRes, accountsRes]) => {
      next(vm => {
        vm.settings = settingsRes.data
        vm.connectedAccounts = accountsRes.data
      })
    })
  },

  mounted () {
    VenueService.index('', 1, 1000).then((response) => {
      this.venues = response.data.data
    })

    if (this.error) {
      this.$notify.error(this.$t(this.error))

      if (this.error.includes('youtube.')) {
        this.youtubeError = this.error
      }
    }
  },

  methods: {
    connectToYoutube () {
      ConnectedAccountService.getYoutubeAuthUrl().then((response) => {
        window.location = response.data.authUrl
      })
    },

    disconnectAccount (account) {
      ConnectedAccountService.disconnectAccount(account.id).then(() => {
        this.refreshAccounts()
      })
    },

    refreshAccounts () {
      ConnectedAccountService.index().then((response) => {
        this.connectedAccounts = response.data
      })
    },

    onSubmit () {
      SettingsService.storeLivestream(this.settings).then(async () => {
        this.form.$errors = {}
        await this.$store.dispatch('getClient')
        this.$store.commit('loaded')
      }).catch((err) => {
        this.form.$errors = err.response.data.errors
      })
    },

    getLiveStreamWidgetLink (venue) {
      return `${this.getWebsiteDomain()}/venues/${venue.uuid}/broadcast-game`
    },

    copyLiveStreamWidgetLink (venue) {
      this.$copyText(this.getLiveStreamWidgetLink(venue)).then(() => {
        this.$toast.fire({
          title: 'Copied to clipboard',
          icon: 'success'
        })
      })
    }
  }
}
</script>
